<template>
  <div class="password">
    <h2 v-if="title"
      v-text="title"
      class="password-title" />
    <div v-if="info"
      class="password-info">
      {{ info }}
    </div>
    <ul class="password-security"
      :class="shakeClass"
      @touchstart.stop="$emit('focus')">
      <li v-for="item in 6"
        @animationend="onAnimationEnd(item)"
        :key="item">
        <i v-if="value.length >= item" />
      </li>
    </ul>
    <div v-if="errorInfo"
      class="password-error-info">
      {{ errorInfo }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'password',
  data() {
    return {
      shakeClass: ''
    };
  },
  props: {
    info: String,
    title: String,
    value: String,
    errorInfo: String
  },
  watch: {
    value(newValue, oldValue) {
      // 从0位到1位
      if (newValue && !oldValue) {
        this.$emit('update:errorInfo', '');
      }
    },
    errorInfo(newVal) {
      if (newVal) {
        this.shakeClass = 'password-shake';
      }
    }
  },
  methods: {
    onAnimationEnd(index) {
      if (index === 1) {
        this.shakeClass = '';
        this.$emit('input', '');
      }
    }
  }
});
</script>

<style lang="less">
.password {
  user-select: none;
  position: relative;
  margin: 0 0.56rem;

  // 去除浏览器默认轮廓线
  &:focus {
    outline: none;
  }

  // 标题
  &-title {
    text-align: center;
    font-weight: normal;
    margin: 1.24rem 0 0.66rem;
    font-size: 24px;
  }

  // 提示
  &-info {
    font-size: 0.28rem;
    line-height: 1;
    margin-top: 0.2rem;
    color: #999;
  }

  // 报错信息
  &-error-info {
    font-size: 0.24rem;
    margin-top: 0.4rem;
    line-height: 1;
    color: #ff411a;
  }

  // 输入框
  &-security {
    display: flex;
    box-sizing: content-box;
    justify-content: space-between;

    // 输入框 - 格子
    li {
      width: 0.9rem;
      height: 0.9rem;
      box-sizing: border-box;
      position: relative;
      border: 1px solid #d5d5d5;
      border-radius: 2px;
      background-color: #fafafa;
    }

    // 输入框 - 点
    i {
      top: 50%;
      left: 50%;
      position: absolute;
      width: 11px;
      height: 11px;
      margin-top: -5.5px;
      margin-left: -5.5px;
      border-radius: 100%;
      background-color: #333;
    }
  }
  // 小黑点 - 震动
  &-shake {
    i {
      animation: password-shake 0.4s both;
    }
    @keyframes password-shake {
      10%,
      30%,
      50%,
      70%,
      90% {
        transform: translate3d(-5px, 0, 0);
      }
      20%,
      40%,
      60%,
      80% {
        transform: translate3d(5px, 0, 0);
      }
    }
  }
}
.password-security {
  margin-top: 0.8rem;
}

.hairline {
  .password {
    &-security,
    &-security li {
      border-width: 0.5px;
    }
  }
}
</style>
